import React from "react";
import ReactDOM from "react-dom";

import { Provider } from "react-redux";
import store from "redux/store";

import { CookiesProvider } from "react-cookie";
import { I18nContextProvider } from "./utils/i18n/locale";
import axiosConfig from "./config/axios/axios.config";

import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

axiosConfig.requestObserver();
axiosConfig.authCredentials();

ReactDOM.render(
  <Provider store={store}>
    <CookiesProvider>
      <I18nContextProvider>
        <App />
      </I18nContextProvider>
    </CookiesProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
